/**
 * Garden Field Mapping
 * Maps field names to their display labels (matching groundworks_rates_mapping.json)
 */

export const GARDEN_FIELD_LABELS: { [fieldName: string]: string } = {
  // Base measurements (matching JSON frontend_label)
  'scaffoldPlatform': 'Scaffold Platform (m²)',
  'geotextileLayer': 'Geotextile Layer (m²)',
  'harrowGardens': 'Harrow gardens to 300mm depth (m²)',
  'plotClearance': 'Remove general builders rubbish prior to topsoiling - if separate (m²)',

  // Dynamic fields
  'thickNoDigLayer': "xxxmm thick 'no dig' layer (m²)",
  'spreadLevelCleanSubsoilCapSiteWon': 'Spread and level xxxmm thick site won clean subsoil capping layer (m²)',
  'spreadLevelCleanSubsoilCapImported': 'Spread and level xxxmm thick imported clean subsoil capping layer (m²)',
  'spreadLevelTopsoilSiteWon': 'Spread and level xxxmm thick site won topsoil (m²)',
  'spreadLevelTopsoilImported': 'Spread and level xxxmm thick imported topsoil (m²)',
};

/**
 * Units for Garden fields
 */
export const GARDEN_FIELD_UNITS: { [fieldName: string]: string } = {
  'scaffoldPlatform': 'm²',
  'thickNoDigLayer': 'm²',
  'geotextileLayer': 'm²',
  'spreadLevelCleanSubsoilCapSiteWon': 'm²',
  'spreadLevelCleanSubsoilCapImported': 'm²',
  'harrowGardens': 'm²',
  'plotClearance': 'm²',
  'spreadLevelTopsoilSiteWon': 'm²',
  'spreadLevelTopsoilImported': 'm²',
};

/**
 * Get the display label for a Garden field
 */
export function getGardenFieldLabel(fieldName: string): string | null {
  return GARDEN_FIELD_LABELS[fieldName] || null;
}

/**
 * Get the unit for a Garden field
 */
export function getGardenFieldUnit(fieldName: string): string | null {
  return GARDEN_FIELD_UNITS[fieldName] || null;
}
